import template from './incompletedocumentation.html';
import controller from './incompletedocumentation.controller';
import './incompletedocumentation.styl';

let incompletedocumentationComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default incompletedocumentationComponent;



// WEBPACK FOOTER //
// ./client/app/common/reports/incompletedocumentation/incompletedocumentation.component.js